import React, { useState, useEffect } from 'react';

import { getTodayDate } from "../../hocs/dateServices";
import { notification } from '../../hocs/notification';
import axios from 'axios';
import { mainurl } from '../../../Mainurl';

import { 
    Row, 
    Col, 
    Card, 
    CardBody, 
    CardHeader, 
    Input, 
    Label, 
    Button, 
    Form, 
    CardFooter,
    Badge,
    Alert,
    Spinner,
    InputGroup,
    InputGroupText
} from 'reactstrap';
import { 
    FaPlusCircle, 
    FaEdit, 
    FaTrash, 
    FaArrowLeft,
    FaFileInvoiceDollar,
    FaShoppingCart,
    FaRupeeSign,
    FaCalendarAlt,
    FaUser,
    FaBuilding,
    FaCreditCard,
    FaSave,
    FaPlus,
    FaTimes,
    FaCheckCircle,
    FaExclamationTriangle
} from 'react-icons/fa';

const InputPaymentScreen = ({back, ...props}) => {

    const [loading, setLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);

    const [state, setState] = useState('0');
    const [district, setDistrict] = useState('0');
    const [block, setBlock] = useState('0');
    
    const [stateOpt, setStateOpt] = useState('');
    const [districtOpt, setDistrictOpt] = useState('');
    const [blockOpt, setBlockOpt] = useState('');
    const [prodOpt, setProdOpt] = useState('');
    const [farmerList, setFarmerList] = useState('');
    const [vendorList, setVendorList] = useState('');
    const [buyerList, setBuyerList] = useState('');

    const [farmer, setFarmer] = useState('');
    const [vendor, setVendor] = useState('');
    const [buyer, setBuyer] = useState('');
    
    const [category, setCategory] = useState('');
    const [product, setProduct] = useState('');
    const [productName, setProductName] = useState('');
    const [rate, setRate] = useState('');
    const [qty, setQty] = useState('');
    const [unit, setUnit] = useState();
    const [unitName, setUnitName] = useState('');
    const [gst, setGst] = useState('');

    const [addList, setAddList] = useState('');
    const [addListArry, setAddListArry] = useState([]);
    const [currRow, setCurrRow] = useState('');
    const [updateRow, setUpdateRow] = useState(false);
    const [totalPrice, setTotalPrice] = useState('');
    const [paymentType, setPaymentType] = useState('Payment');
    const [paymentTo, setPaymentTo] = useState('');
    const [payMode, setPayMode] = useState('');

    const [bankList, setBankList] = useState([]);
    const [ledgerList, setLedgerList] = useState([]);
    const [selectedBank, setSelectedBank] = useState('');
    const [selectedLedger, setSelectedLedger] = useState('');
    const [utrNo, setUtrNo] = useState('');
    const [chequeNo, setChequeNo] = useState('');
    const [payAmount, setPayAmount] = useState('');
    const [payDate, setPayDate] = useState('');
    const [invoiceNumber, setInvoiceNumber] = useState('');
    const [invoiceDate, setInvoiceDate] = useState('');

    const [coaList, setCoaList] = useState([]);
    const [selectedCOA, setSelectedCOA] = useState('');

    useEffect(()=> {
        get_product_list();
        get_state_list();
    },[]);

    const get_state_list = (e) => {
        let postData = [{"country_code": "1"}]
        axios({
            method: 'post',
            url: mainurl + 'Master/get_state_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return(
                        <option key={row.state_code} value={row.state_code}> {row.state_name}</option>
                    )
                });
                setStateOpt(list);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const get_dist_list = (e) => {
        setState(e.target.value);
        let postData = [{"state_code": e.target.value}]
        axios({
            method: 'post',
            url: mainurl + 'Master/get_dist_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return(
                        <option key={row.district_code} value={row.district_code}> {row.district_name}</option>
                    )
                });
                setDistrictOpt(list);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const get_block_list = (e) => {
        setDistrict(e.target.value);
        let postData = [{"dist_code": e.target.value}]
        axios({
            method: 'post',
            url: mainurl + 'Master/get_block_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return(
                        <option key={row.block_code} value={row.block_code}> {row.block_name}</option>
                    )
                });
                setBlockOpt(list);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const fetchCOAList = async (setCOAList) => {
        try {
            const response = await axios.post(
                'https://api2.boxfarming.in/wsapi/v3/index.php/Accounts/coa_list',
                [{"org_id":114,"user_id":10055,"ac_group_id":0}],
                { headers: { 'Content-Type': 'application/JSON' } }
            );
            setCOAList(response.data);
        } catch (error) {
            setCOAList([]);
        }
    };

    const get_product_list = () => {
        setLoading(true);
        const postData = [{"org_id":114,"user_id":10055,"item_type_id":1}];
        axios({
            method: 'post',
            url: 'https://api2.boxfarming.in/wsapi/v3/index.php/Accounts/item_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON' },
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        <option value={row.item_id} key={row.item_id}>
                            {row.item_name} (ID: {row.item_id}) ({row.brand}) - {row.manufacturer} | GST: {row.gst}%
                        </option>
                    );
                });
                setProdOpt(list);
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const add_row_handler = (e) => {
        e.preventDefault();

        if (!product || !qty || !rate || !unit || !gst) {
            let notify = notification({ 
                message: "Please fill all required fields", 
                type: 'error',
                position: 'center' 
            });
            notify();
            return;
        }

        let list = { 
            "product": product, 
            "productName": productName, 
            "qty": qty, 
            "unit": unit, 
            "unitName": unitName, 
            "rate": rate, 
            "gst": gst 
        };
        let tempArry = [...addListArry, list];
        
        setAddListArry(tempArry);
        
        let total = 0;
        if (tempArry.length > 0) {
            total = tempArry.reduce((sum, row) => {
                const baseTotal = Number(row.rate) * Number(row.qty);
                const gstAmt = baseTotal * (Number(row.gst) || 0) / 100;
                return sum + baseTotal + gstAmt;
            }, 0);
            setTotalPrice(total);
            
            // Clear form
            setProduct('');
            setProductName('');
            setQty('');
            setUnit('');
            setUnitName('');
            setRate('');
            setGst('');

            let notify = notification({ 
                message: "Product added successfully", 
                type: 'success',
                position: 'top-right' 
            });
            notify();
        }
    }

    const edit_handler = (row, rowNo) => {
        setCurrRow(rowNo);
        setUpdateRow(true);
        setProduct(row.product);
        setProductName(row.productName);
        setQty(row.qty);
        setUnit(row.unit);
        setUnitName(row.unitName);
        setRate(row.rate);
        setGst(row.gst);
    }

    const update_edit_handler = () => {
        if (!product || !qty || !rate || !unit || !gst) {
            let notify = notification({ 
                message: "Please fill all required fields", 
                type: 'error',
                position: 'center' 
            });
            notify();
            return;
        }

        let list = { 
            "product": product, 
            "productName": productName, 
            "qty": qty, 
            "unit": unit, 
            "unitName": unitName, 
            "rate": rate, 
            "gst": gst 
        };
        let updateList = [...addListArry];
        updateList.splice(currRow, 1, list);

        setAddListArry(updateList);
        
        let total = updateList.reduce((sum, row) => {
            const baseTotal = Number(row.rate) * Number(row.qty);
            const gstAmt = baseTotal * (Number(row.gst) || 0) / 100;
            return sum + baseTotal + gstAmt;
        }, 0);
        setTotalPrice(total);
        
        // Clear form
        setProduct('');
        setProductName('');
        setQty('');
        setUnit('');
        setUnitName('');
        setRate('');
        setGst('');
        setCurrRow('');
        setUpdateRow(false);

        let notify = notification({ 
            message: "Product updated successfully", 
            type: 'success',
            position: 'top-right' 
        });
        notify();
    }

    const delete_handler = (rowNo) => {
        let delListArry = [...addListArry];
        delListArry.splice(rowNo, 1);
        setAddListArry(delListArry);
        
        let total = delListArry.reduce((sum, row) => {
            const baseTotal = Number(row.rate) * Number(row.qty);
            const gstAmt = baseTotal * (Number(row.gst) || 0) / 100;
            return sum + baseTotal + gstAmt;
        }, 0);
        setTotalPrice(total);

        let notify = notification({ 
            message: "Product removed successfully", 
            type: 'info',
            position: 'top-right' 
        });
        notify();
    }

    const sale_handler = () => {
        if (addListArry.length === 0) {
            let notify = notification({ 
                message: "Please add at least one product", 
                type: 'error',
                position: 'center' 
            });
            notify();
            return;
        }

        setSubmitLoading(true);

        const unitMap = { "Gm": "1", "Kg": "2", "Ton": "3", "Packet": "4" };
        const products = addListArry.map(row => ({
            product_id: row.product,
            unit_price: Number(row.rate),
            qty: Number(row.qty),
            uom: Number(unitMap[row.unitName.trim()] || row.unit),
            tax: Number(row.gst),
            sale_price: Number(row.qty) * Number(row.rate)
        }));

        let desc = "";
        if (paymentTo === "Farmer") desc = "Payment to Farmer";
        else if (paymentTo === "Vendor") desc = "Payment to Vendor";
        else if (paymentTo === "Buyer") desc = "Payment to Buyer";
        else desc = "Payment";

        let paymentTypeNum = 1;
        if (paymentType === "Payment") paymentTypeNum = 1;
        else if (paymentType === "Receipt") paymentTypeNum = 2;
        else if (paymentType === "Contra") paymentTypeNum = 3;
        else if (paymentType === "Journal") paymentTypeNum = 4;

        let mode = "0";
        let bank_id = "0";
        let cheque_no= "0";
        let utr_no = "0";
        let amount = "";
        let date = "";
        if (payMode === "Online") {
            mode= "1";
            bank_id= selectedBank;
            utr_no= utrNo;
            amount= payAmount;
            date= payDate;
        } else if (payMode === "Cheque") {
            mode= "2";
            bank_id= selectedBank;
            cheque_no= chequeNo;
            amount= payAmount;
            date= payDate;
        } else if (payMode === "Cash") {
            mode= "3";
            amount= payAmount;
            date= payDate;
        }

        // Use GST from first product (or 0 if none)
        const gst = products.length > 0 ? products[0].tax : 0;

        // Build the payload
        const postData = [{
            org_id: Number(sessionStorage.getItem('org_id')),
            user_id: Number(sessionStorage.getItem('user_id')),
            invoice_no: invoiceNumber,
            desc,
            invoice_date: invoiceDate,
            fpo_ac: Number(selectedCOA),
            ledger_id: Number(selectedLedger),
            trn_type: 1,
            payment_type: paymentTypeNum,
            mode,
            bank_id,
            utr_no,
            cheque_no,
            amount,
            date,
            gst,
            products
        }];

        axios({
            method: 'post',
            url: mainurl + 'Accounts/journal_entry',
            data: postData,
            headers: { 'Content-Type': 'application/JSON' }
        })
            .then(function (response) {
                let notify = notification({ 
                    message: "Transaction submitted successfully!", 
                    type: 'success', 
                    time: true, 
                    position: 'center' 
                });
                notify();
                setTimeout(() => {
                    back();
                }, 1500);
            })
            .catch(error => {
                let notify = notification({ 
                    message: "Failed to submit transaction. Please try again.", 
                    type: 'error',
                    position: 'center' 
                });
                notify();
            })
            .finally(() => {
                setSubmitLoading(false);
            });
    }

    useEffect(() => {
        if (payMode === 'Online' || payMode === 'Cheque') {
            const postData = [{"org_id":"114","user_id":"10056"}];
            axios.post(
                'https://api2.boxfarming.in/wsapi/v3/index.php/Accounts/view_bank_list',
                postData,
                { headers: { 'Content-Type': 'application/JSON' } }
            )
            .then(res => setBankList(res.data))
            .catch(() => setBankList([]));
            get_ledger_account_list();
        }
        if (payMode === 'Cash') {
            get_ledger_account_list();
        }
    }, [payMode]);

    useEffect(() => {
        if (paymentTo) {
            axios.post(
                'https://api2.boxfarming.in/wsapi/v3/index.php/Accounts/coa_list',
                [{"org_id":114,"user_id":10055,"ac_group_id":0}],
                { headers: { 'Content-Type': 'application/JSON' } }
            ).then(res => setCoaList(res.data)).catch(() => setCoaList([]));
        }
    }, [paymentTo]);

    const get_ledger_account_list = () => {
        const postData = [{"org_id":114,"user_id":10055,"ac_group_id":1}];
        axios({
            method: 'post',
            url: 'https://api2.boxfarming.in/wsapi/v3/index.php/Accounts/coa_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON' },
        })
            .then(function (response) {
                setLedgerList(response.data);
            })
            .catch(error => {
                setLedgerList([]);
            });
    };

    const calculateTotals = () => {
        const baseTotal = addListArry.reduce((sum, row) => sum + (Number(row.rate) * Number(row.qty)), 0);
        const gstTotal = addListArry.reduce((sum, row) => {
            const itemTotal = Number(row.rate) * Number(row.qty);
            return sum + (itemTotal * (Number(row.gst) || 0) / 100);
        }, 0);
        const grandTotal = baseTotal + gstTotal;
        
        return { baseTotal, gstTotal, grandTotal };
    };

    const { baseTotal, gstTotal, grandTotal } = calculateTotals();

    return(
        <>
            {/* Header Card */}
            <Card className='mb-4 border-0 shadow-sm'>
                <CardHeader className='bg-white border-bottom-0'>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-3">
                            <div className="d-flex align-items-center gap-2">
                                <FaFileInvoiceDollar className="text-primary" size={24} />
                                <div>
                                    <h5 className="mb-0">Create New Transaction</h5>
                                    <small className="text-muted">Add payment/receipt entries with product details</small>
                                </div>
                            </div>
                        </div>
                        <Button 
                            color='outline-secondary' 
                            size="sm" 
                            onClick={back}
                            className="d-flex align-items-center gap-2"
                        > 
                            <FaArrowLeft size={14} />
                            Back to List
                        </Button>
                    </div>
                </CardHeader>
                <CardBody className="py-3">
                    <Row>
                        <Col md={3} className="mb-3">
                            <Label className="fw-bold text-muted mb-2">
                                <FaFileInvoiceDollar className="me-2" size={14} />
                                Transaction Type
                            </Label>
                            <Input 
                                bsSize="sm" 
                                type="select" 
                                value={paymentType} 
                                onChange={e => {setPaymentType(e.target.value); setPaymentTo('');}}
                                className="form-select-sm"
                            >
                                <option value="">--Select Type--</option>
                                <option value="Payment">Payment</option>
                                <option value="Receipt">Receipt</option>
                                <option value="Contra">Contra</option>
                                <option value="Journal">Journal</option>
                            </Input>
                        </Col>
                        {(paymentType === 'Payment' || paymentType === 'Receipt') && (
                            <Col md={3} className="mb-3">
                                <Label className="fw-bold text-muted mb-2">
                                    <FaUser className="me-2" size={14} />
                                    {paymentType === 'Payment' ? 'Payment To' : 'Receive From'}
                                </Label>
                                <Input 
                                    bsSize="sm" 
                                    type="select" 
                                    value={paymentTo} 
                                    onChange={e => setPaymentTo(e.target.value)}
                                    className="form-select-sm"
                                >
                                    <option value="">--Select Party--</option>
                                    <option value="Farmer">Farmer</option>
                                    <option value="Vendor">Vendor</option>
                                    <option value="Buyer">Buyer</option>
                                </Input>
                            </Col>
                        )}
                        {(paymentTo === 'Farmer' || paymentTo === 'Vendor' || paymentTo === 'Buyer') && (
                            <Col md={3} className="mb-3">
                                <Label className="fw-bold text-muted mb-2">
                                    <FaBuilding className="me-2" size={14} />
                                    {paymentTo} Account
                                </Label>
                                <Input 
                                    bsSize="sm" 
                                    type="select" 
                                    value={selectedCOA} 
                                    onChange={e => setSelectedCOA(e.target.value)} 
                                    required
                                    className="form-select-sm"
                                >
                                    <option value="">--Select Account--</option>
                                    {coaList.map((row, idx) => (
                                        <option key={row.account_code} value={row.account_code}>
                                            {row.account_name} ({row.account_code})
                                        </option>
                                    ))}
                                </Input>
                            </Col>
                        )}
                        <Col md={3} className="mb-3">
                            <Label className="fw-bold text-muted mb-2">
                                <FaFileInvoiceDollar className="me-2" size={14} />
                                Invoice Number
                            </Label>
                            <Input 
                                bsSize="sm" 
                                type="text" 
                                value={invoiceNumber} 
                                onChange={e => setInvoiceNumber(e.target.value)} 
                                placeholder="Enter invoice number"
                                className="form-control-sm"
                            />
                        </Col>
                        <Col md={3} className="mb-3">
                            <Label className="fw-bold text-muted mb-2">
                                <FaCalendarAlt className="me-2" size={14} />
                                Invoice Date
                            </Label>
                            <Input 
                                bsSize="sm" 
                                type="date" 
                                value={invoiceDate} 
                                onChange={e => setInvoiceDate(e.target.value)}
                                className="form-control-sm"
                            />
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            {/* Product Addition Card */}
            <Card className='mb-4 border-0 shadow-sm'>
                <CardHeader className="bg-light border-bottom">
                    <div className="d-flex align-items-center gap-2">
                        <FaShoppingCart className="text-primary" />
                        <h6 className="mb-0">Add Products</h6>
                        {loading && <Spinner size="sm" className="ms-2" />}
                    </div>
                </CardHeader>
                <CardBody>
                    <Form onSubmit={add_row_handler}>
                        <Row className="align-items-end mb-3">
                            <Col md={3} className="mb-3">
                                <Label className="fw-bold text-muted mb-2">
                                    <FaShoppingCart className="me-2" size={12} />
                                    Product
                                </Label>
                                <Input 
                                    bsSize="sm" 
                                    type="select" 
                                    value={product} 
                                    onChange={e => {
                                        setProduct(e.target.value); 
                                        setProductName(e.target.selectedOptions[0].text);
                                    }}
                                    required
                                    className="form-select-sm"
                                >
                                    <option value="0">--Select Product--</option>
                                    {prodOpt}
                                </Input>
                            </Col>
                            <Col md={2} className="mb-3">
                                <Label className="fw-bold text-muted mb-2">Quantity</Label>
                                <Input 
                                    bsSize="sm" 
                                    type="number" 
                                    value={qty} 
                                    onChange={e => setQty(e.target.value)} 
                                    placeholder="0"
                                    min="0"
                                    step="0.01"
                                    required
                                    className="form-control-sm"
                                />  
                            </Col>
                            <Col md={2} className="mb-3">
                                <Label className="fw-bold text-muted mb-2">Rate/Unit</Label>
                                <InputGroup size="sm">
                                    <InputGroupText className="bg-light">₹</InputGroupText>
                                    <Input 
                                        type="number" 
                                        value={rate} 
                                        onChange={e => setRate(e.target.value)} 
                                        placeholder="0.00"
                                        min="0"
                                        step="0.01"
                                        required
                                        className="form-control-sm"
                                    />
                                </InputGroup>
                            </Col>
                            <Col md={2} className="mb-3">
                                <Label className="fw-bold text-muted mb-2">Unit</Label>
                                <Input 
                                    bsSize="sm" 
                                    type="select" 
                                    value={unit} 
                                    onChange={e => {
                                        setUnit(e.target.value);  
                                        setUnitName(e.target.selectedOptions[0].text);
                                    }} 
                                    required
                                    className="form-select-sm"
                                >
                                    <option value="0">--Select Unit--</option>
                                    <option value="1">Gm</option>
                                    <option value="2">Kg</option>
                                    <option value="3">Ton</option>
                                    <option value="4">Packet</option>
                                </Input>
                            </Col>
                            <Col md={2} className="mb-3">
                                <Label className="fw-bold text-muted mb-2">GST (%)</Label>
                                <Input 
                                    bsSize="sm" 
                                    type="number" 
                                    value={gst} 
                                    onChange={e => setGst(e.target.value)} 
                                    placeholder="0"
                                    min="0" 
                                    max="100" 
                                    step="0.01" 
                                    required
                                    className="form-control-sm"
                                />
                            </Col>
                            <Col md={1} className="mb-3">
                                { updateRow ? (
                                    <Button 
                                        color='success' 
                                        size="sm" 
                                        onClick={update_edit_handler}
                                        className="w-100 d-flex align-items-center justify-content-center gap-1"
                                    > 
                                        <FaCheckCircle size={14} />
                                        Update
                                    </Button>
                                ) : (
                                    <Button 
                                        color='primary' 
                                        size="sm" 
                                        type="submit"
                                        className="w-100 d-flex align-items-center justify-content-center gap-1"
                                    > 
                                        <FaPlus size={14} />
                                        Add
                                    </Button>
                                )}
                            </Col>
                        </Row>
                    </Form>
                </CardBody>
            </Card> 

            {/* Products List Card */}
            {addListArry.length > 0 && (
                <Card className='mb-4 border-0 shadow-sm'>
                    <CardHeader className="bg-light border-bottom">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center gap-2">
                                <FaShoppingCart className="text-primary" />
                                <h6 className="mb-0">Added Products</h6>
                                <Badge color="primary" pill>{addListArry.length}</Badge>
                            </div>
                            <small className="text-muted">
                                Total Items: {addListArry.reduce((sum, row) => sum + Number(row.qty), 0)}
                            </small>
                        </div>
                    </CardHeader>
                    <CardBody className="p-0">
                        <div className="table-responsive">
                            <table className="table table-hover mb-0">
                                <thead className="bg-light">
                                    <tr>
                                        <th className="border-0 text-center" style={{width: '120px'}}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {addListArry.map((row, index) => {
                                        const baseTotal = Number(row.rate) * Number(row.qty);
                                        const gstAmt = baseTotal * (Number(row.gst) || 0) / 100;
                                        const totalWithGst = baseTotal + gstAmt;
                                        return (
                                            <tr key={index} className="align-middle">
                                                <td className="text-center">
                                                    <Badge color="light" className="text-dark">{index + 1}</Badge>
                                                </td>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <FaShoppingCart className="text-muted me-2" size={14} />
                                                        <div>
                                                            <div className="fw-bold text-truncate" style={{maxWidth: '200px'}} title={row.productName}>
                                                                {row.productName}
                                                            </div>
                                                            <small className="text-muted">Unit: {row.unitName}</small>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <Badge color="info" className="font-monospace">{row.qty}</Badge>
                                                </td>
                                                <td className="text-center">
                                                    <span className="fw-bold text-success">₹{Number(row.rate).toFixed(2)}</span>
                                                </td>
                                                <td className="text-center">
                                                    <Badge color="secondary" outline>{row.gst || 0}%</Badge>
                                                </td>
                                                <td className="text-center">
                                                    <span className="text-warning fw-bold">₹{gstAmt.toFixed(2)}</span>
                                                </td>
                                                <td className="text-center">
                                                    <span className="fw-bold text-primary">₹{totalWithGst.toFixed(2)}</span>
                                                </td>
                                                <td className="text-center">
                                                    <div className="d-flex gap-1 justify-content-center">
                                                        <Button 
                                                            color='info' 
                                                            size='sm' 
                                                            outline
                                                            onClick={()=>edit_handler(row, index)}
                                                            title="Edit Product"
                                                        >
                                                            <FaEdit size={12} />
                                                        </Button>
                                                        <Button 
                                                            color='danger' 
                                                            size='sm' 
                                                            outline
                                                            onClick={()=>delete_handler(index)}
                                                            title="Remove Product"
                                                        >
                                                            <FaTrash size={12} />
                                                        </Button>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                        
                        {/* Summary Footer */}
                        <div className="border-top bg-light p-3">
                            <Row>
                                <Col md={6}>
                                    <div className="d-flex gap-4">
                                        <div>
                                            <small className="text-muted d-block">Total Items</small>
                                            <span className="fw-bold">{addListArry.length}</span>
                                        </div>
                                        <div>
                                            <small className="text-muted d-block">Total Quantity</small>
                                            <span className="fw-bold">{addListArry.reduce((sum, row) => sum + Number(row.qty), 0)}</span>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6} className="text-end">
                                    <div className="d-flex flex-column gap-1">
                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted">Subtotal:</span>
                                            <span className="fw-bold">₹{baseTotal.toFixed(2)}</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted">GST Amount:</span>
                                            <span className="fw-bold text-warning">₹{gstTotal.toFixed(2)}</span>
                                        </div>
                                        <div className="d-flex justify-content-between border-top pt-1">
                                            <span className="fw-bold">Grand Total:</span>
                                            <span className="fw-bold text-success fs-5">₹{grandTotal.toFixed(2)}</span>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </CardBody>
                </Card>
            )}

            {/* Payment Details Card */}
            {addListArry.length > 0 && (
                <Card className='mb-4 border-0 shadow-sm'>
                    <CardHeader className="bg-light border-bottom">
                        <div className="d-flex align-items-center gap-2">
                            <FaCreditCard className="text-primary" />
                            <h6 className="mb-0">Payment Details</h6>
                        </div>
                    </CardHeader>
                    <CardBody>
                        <Row className="mb-3">
                            <Col md={4} className="mb-3">
                                <Label className="fw-bold text-muted mb-2">
                                    <FaCreditCard className="me-2" size={14} />
                                    {paymentType === 'Payment' ? 'Payment Mode' : paymentType === 'Receipt' ? 'Receipt Mode' : 'Transaction Mode'}
                                </Label>
                                <Input 
                                    bsSize="sm" 
                                    type="select" 
                                    value={payMode} 
                                    onChange={e => setPayMode(e.target.value)}
                                    className="form-select-sm"
                                >
                                    <option value="">--Select Mode--</option>
                                    <option value="Online">Online Transfer</option>
                                    <option value="Cash">Cash</option>
                                    <option value="Cheque">Cheque</option>
                                </Input>
                            </Col>
                        </Row>

                        {/* Payment Mode Specific Fields */}
                        {payMode === 'Online' && (
                            <Alert color="info" className="mb-3">
                                <FaExclamationTriangle className="me-2" />
                                <strong>Online Transfer Details</strong>
                                <Row className="mt-3">
                                    <Col md={3} className="mb-3">
                                        <Label className="fw-bold text-muted mb-2">Bank</Label>
                                        <Input 
                                            type="select" 
                                            value={selectedBank} 
                                            onChange={e => setSelectedBank(e.target.value)}
                                            bsSize="sm"
                                            className="form-select-sm"
                                        >
                                            <option value="">--Select Bank--</option>
                                            {bankList.map(b => (
                                                <option key={b.bank_id} value={b.bank_id}>{b.bank_name}</option>
                                            ))}
                                        </Input>
                                    </Col>
                                    <Col md={3} className="mb-3">
                                        <Label className="fw-bold text-muted mb-2">UTR Number</Label>
                                        <Input 
                                            type="text" 
                                            value={utrNo} 
                                            onChange={e => setUtrNo(e.target.value)} 
                                            placeholder="Enter UTR number"
                                            bsSize="sm"
                                        />
                                    </Col>
                                    <Col md={3} className="mb-3">
                                        <Label className="fw-bold text-muted mb-2">Amount</Label>
                                        <InputGroup size="sm">
                                            <InputGroupText className="bg-light">₹</InputGroupText>
                                            <Input 
                                                type="number" 
                                                value={payAmount} 
                                                onChange={e => setPayAmount(e.target.value)} 
                                                placeholder="0.00"
                                                min="0"
                                                step="0.01"
                                            />
                                        </InputGroup>
                                    </Col>
                                    <Col md={3} className="mb-3">
                                        <Label className="fw-bold text-muted mb-2">Date</Label>
                                        <Input 
                                            type="date" 
                                            value={payDate} 
                                            onChange={e => setPayDate(e.target.value)}
                                            bsSize="sm"
                                        />
                                    </Col>
                                </Row>
                            </Alert>
                        )}

                        {payMode === 'Cheque' && (
                            <Alert color="warning" className="mb-3">
                                <FaExclamationTriangle className="me-2" />
                                <strong>Cheque Payment Details</strong>
                                <Row className="mt-3">
                                    <Col md={3} className="mb-3">
                                        <Label className="fw-bold text-muted mb-2">Bank</Label>
                                        <Input 
                                            type="select" 
                                            value={selectedBank} 
                                            onChange={e => setSelectedBank(e.target.value)}
                                            bsSize="sm"
                                            className="form-select-sm"
                                        >
                                            <option value="">--Select Bank--</option>
                                            {bankList.map(b => (
                                                <option key={b.bank_id} value={b.bank_id}>{b.bank_name}</option>
                                            ))}
                                        </Input>
                                    </Col>
                                    <Col md={3} className="mb-3">
                                        <Label className="fw-bold text-muted mb-2">Cheque Number</Label>
                                        <Input 
                                            type="text" 
                                            value={chequeNo} 
                                            onChange={e => setChequeNo(e.target.value)} 
                                            placeholder="Enter cheque number"
                                            bsSize="sm"
                                        />
                                    </Col>
                                    <Col md={3} className="mb-3">
                                        <Label className="fw-bold text-muted mb-2">Amount</Label>
                                        <InputGroup size="sm">
                                            <InputGroupText className="bg-light">₹</InputGroupText>
                                            <Input 
                                                type="number" 
                                                value={payAmount} 
                                                onChange={e => setPayAmount(e.target.value)} 
                                                placeholder="0.00"
                                                min="0"
                                                step="0.01"
                                            />
                                        </InputGroup>
                                    </Col>
                                    <Col md={3} className="mb-3">
                                        <Label className="fw-bold text-muted mb-2">Date</Label>
                                        <Input 
                                            type="date" 
                                            value={payDate} 
                                            onChange={e => setPayDate(e.target.value)}
                                            bsSize="sm"
                                        />
                                    </Col>
                                </Row>
                            </Alert>
                        )}

                        {payMode === 'Cash' && (
                            <Alert color="success" className="mb-3">
                                <FaExclamationTriangle className="me-2" />
                                <strong>Cash Payment Details</strong>
                                <Row className="mt-3">
                                    <Col md={4} className="mb-3">
                                        <Label className="fw-bold text-muted mb-2">Amount</Label>
                                        <InputGroup size="sm">
                                            <InputGroupText className="bg-light">₹</InputGroupText>
                                            <Input 
                                                type="number" 
                                                value={payAmount} 
                                                onChange={e => setPayAmount(e.target.value)} 
                                                placeholder="0.00"
                                                min="0"
                                                step="0.01"
                                            />
                                        </InputGroup>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                        <Label className="fw-bold text-muted mb-2">Date</Label>
                                        <Input 
                                            type="date" 
                                            value={payDate} 
                                            onChange={e => setPayDate(e.target.value)}
                                            bsSize="sm"
                                        />
                                    </Col>
                                </Row>
                            </Alert>
                        )}

                        {/* Ledger Account Selection */}
                        {(payMode === 'Online' || payMode === 'Cash' || payMode === 'Cheque') && (
                            <Row className="mb-3">
                                <Col md={4}>
                                    <Label className="fw-bold text-muted mb-2">
                                        <FaBuilding className="me-2" size={14} />
                                        Ledger Account
                                    </Label>
                                    <Input 
                                        type="select" 
                                        value={selectedLedger} 
                                        onChange={e => setSelectedLedger(e.target.value)}
                                        bsSize="sm"
                                        className="form-select-sm"
                                    >
                                        <option value="">--Select Ledger--</option>
                                        {ledgerList.map((l, index) => (
                                            <option key={l.account_code || index} value={l.account_code}>
                                                {l.account_name} ({l.account_code})
                                            </option>
                                        ))}
                                    </Input>
                                </Col>
                            </Row>
                        )}
                    </CardBody>
                    <CardFooter className="bg-light border-top">
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <small className="text-muted">
                                    {addListArry.length} product(s) • Total: ₹{grandTotal.toFixed(2)}
                                </small>
                            </div>
                            <Button 
                                color='success' 
                                size='sm' 
                                onClick={sale_handler}
                                disabled={submitLoading || addListArry.length === 0}
                                className="d-flex align-items-center gap-2 px-4"
                            >
                                {submitLoading ? (
                                    <>
                                        <Spinner size="sm" />
                                        Processing...
                                    </>
                                ) : (
                                    <>
                                        <FaSave size={14} />
                                        Submit Transaction
                                    </>
                                )}
                            </Button>
                        </div>
                    </CardFooter>
                </Card>
            )}

            {/* Empty State */}
            {addListArry.length === 0 && (
                <Card className='mb-4 border-0 shadow-sm'>
                    <CardBody className="text-center py-5">
                        <FaShoppingCart size={48} className="text-muted mb-3" />
                        <h6 className="text-muted mb-2">No Products Added</h6>
                        <p className="text-muted mb-0">
                            Add products using the form above to create your transaction
                        </p>
                    </CardBody>
                </Card>
            )}
        </>
    )
}
export default InputPaymentScreen; 